import { useFormikContext } from 'formik';
import React from 'react';

import styled from '@emotion/styled';

import { formatNaira } from '../../../../utils/utils';

const BundlesFormPresentation = () => {
  const { values } = useFormikContext<any>();

  return (
    <Container>
      <BundleFormPresentation>
        <BundleFormPresentationHeader>
          {Number(values.numberOfLookups) ?? 0} look-up
          {Number(values.numberOfLookups) > 1 ? 's' : ''}
        </BundleFormPresentationHeader>
        <BundleFormPresentationFooter>
          <AmountArea>
            <CrossedText>
              {formatNaira(Number(values.originalPrice) ?? 0)}
            </CrossedText>
            <BlueText>{formatNaira(Number(values.newPrice) ?? 0)}</BlueText>
          </AmountArea>
        </BundleFormPresentationFooter>
      </BundleFormPresentation>
      <DiscountArea>{Number(values.discount) ?? 0}% OFF</DiscountArea>
    </Container>
  );
};

export default BundlesFormPresentation;

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: rgba(91, 145, 245, 0.02);
  padding: 12px 20px;
  border-radius: 20px;
`;

const BundleFormPresentation = styled.div`
  flex-direction: column;
  gap: 6px;
`;

const BundleFormPresentationHeader = styled.div`
  font-weight: 700;
  color: #5c5963;
`;

const BundleFormPresentationFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const AmountArea = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  font-weight: 600;
  font-size: 12px;
`;

const CrossedText = styled.div`
  color: #6b7280;
  text-decoration: line-through;
`;

const BlueText = styled.div`
  color: #5b91f5;
`;

const DiscountArea = styled.div`
  background-color: rgba(0, 183, 63, 0.1);
  color: #00b73f;
  padding: 8px 12px;
  border-radius: 20px;
  width: fit-content;
  font-weight: 600;

  align-self: baseline;
`;
